// web/src/copilot/UsageIndicator.tsx
//
// Shows daily message quota inside the chat sheet header.
// Hides itself while loading or when tier=free (the tier-gating in C7 hides
// the button entirely for free users, so this component is never mounted for
// them — but we guard here too for safety).
import { useUsage } from "./api";

export function UsageIndicator() {
  const { data, isPending } = useUsage();

  if (isPending || !data) return null;

  // Free-tier users don't see the button at all (C7); nothing to show here.
  if (data.rate_limit_state === "tier_required") return null;

  return (
    <div className="text-xs text-muted-foreground font-mono">
      {data.messages_used}/{data.messages_limit} messages today
      {data.rate_limit_state === "warning" && (
        <span className="ms-2 text-amber-500">approaching limit</span>
      )}
      {data.rate_limit_state === "messages_exhausted" && (
        <span className="ms-2 text-destructive">
          limit reached — resets at midnight UTC
        </span>
      )}
      {data.rate_limit_state === "cost_safety_cap" && (
        <span className="ms-2 text-destructive">
          cost cap reached — contact support
        </span>
      )}
    </div>
  );
}
